module.exports = __webpack_public_path__ + "img/page-icon-one.5eac2199.svg";